import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('configure')

export const FETCH_LIST = createType('FETCH_LIST')
export const LIST_FETCHED = createType('LIST_FETCHED')
export const SHOW_INFO_DIALOG = createType('SHOW_INFO_DIALOG')
export const HIDE_INFO_DIALOG = createType('HIDE_INFO_DIALOG')
export const TOGGLE_LOADING = createType('TOGGLE_LOADING')
export const SET_ACTIVE_STATE = createType('SET_ACTIVE_STATE')
export const UPDATED = createType('UPDATED')
export const SET_DEFAULT = createType('SET_DEFAULT')
export const DEL_DEFAULT = createType('DEL_DEFAULT')
export const CREATED = createType('CREATED')
